
import { IBulkUpdateFormFolderPathAction, IBulkUpdateFormFolderPathActionPayload, IBulkUpdateFormFolderPathSuccessAction, ICeateFolderAction, ICeateFolderSuccessAction, IDeleteFolderAction, IDeleteFolderSuccessAction, IFetchFoldersByPathAction, IFetchFoldersByPathActionPayload, IFetchFoldersByPathSuccessAction, IFoldersDataServer, IGetFolderByIdAction, IGetFolderByIdSuccessAction, IUpdateFolderAction, IUpdateFolderSuccessAction } from "@common/redux/folders/interface";

const actionTypePrefix = "FOLDERS/";

export const foldersActions = {
  FETCH_FOLDERS_BY_PATH: `${actionTypePrefix}FETCH_FOLDERS_BY_PATH`,
  FETCH_FOLDERS_BY_PATH_SUCCESS: `${actionTypePrefix}FETCH_FOLDERS_BY_PATH_SUCCESS`,
  FETCH_FOLDERS_BY_PATH_FAILURE: `${actionTypePrefix}FETCH_FOLDERS_BY_PATH_FAILURE`,

  CREATE_FOLDER: `${actionTypePrefix}CREATE_FOLDER`,
  CREATE_FOLDER_SUCCESS: `${actionTypePrefix}CREATE_FOLDER_SUCCESS`,
  CREATE_FOLDER_FAILURE: `${actionTypePrefix}CREATE_FOLDER_FAILURE`,

  UPDATE_FOLDER: `${actionTypePrefix}UPDATE_FOLDER`,
  UPDATE_FOLDER_SUCCESS: `${actionTypePrefix}UPDATE_FOLDER_SUCCESS`,
  UPDATE_FOLDER_FAILURE: `${actionTypePrefix}UPDATE_FOLDER_FAILURE`,

  DELETE_FOLDER: `${actionTypePrefix}DELETE_FOLDER`,
  DELETE_FOLDER_SUCCESS: `${actionTypePrefix}DELETE_FOLDER_SUCCESS`,
  DELETE_FOLDER_FAILURE: `${actionTypePrefix}DELETE_FOLDER_FAILURE`,

  FETCH_FOLDER_BY_ID: `${actionTypePrefix}FETCH_FOLDER_BY_ID`,
  FETCH_FOLDER_BY_ID_SUCCESS: `${actionTypePrefix}FETCH_FOLDER_BY_ID_SUCCESS`,
  FETCH_FOLDER_BY_ID_FAILURE: `${actionTypePrefix}FETCH_FOLDER_BY_ID_FAILURE`,

  BULK_UPDATE_FORM_FOLDER_PATH: `${actionTypePrefix}BULK_UPDATE_FORM_FOLDER_PATH`,
  BULK_UPDATE_FORM_FOLDER_PATH_SUCCESS: `${actionTypePrefix}BULK_UPDATE_FORM_FOLDER_PATH_SUCCESS`,
  BULK_UPDATE_FORM_FOLDER_PATH_FAILURE: `${actionTypePrefix}BULK_UPDATE_FORM_FOLDER_PATH_FAILURE`,

};

export const fetchFoldersByPathAction = (
  payload: IFetchFoldersByPathActionPayload
): IFetchFoldersByPathAction => {
  return {
    type: foldersActions.FETCH_FOLDERS_BY_PATH,
    payload,
  };
};

export const fetchFoldersByPathSuccessAction = (
  fetchFoldersByPathApiResponse: IFoldersDataServer[]
): IFetchFoldersByPathSuccessAction => {
  return {
    type: foldersActions.FETCH_FOLDERS_BY_PATH_SUCCESS,
    payload: fetchFoldersByPathApiResponse,
  };
};

export const fetchFoldersByPathFailureAction = (payload: {
  error: string;
}) => {
  return {
    type: foldersActions.FETCH_FOLDERS_BY_PATH_FAILURE,
    payload: payload,
  };
};

export const createFolderAction = (
  payload: IFoldersDataServer
): ICeateFolderAction => {
  return {
    type: foldersActions.CREATE_FOLDER,
    payload,
  };
};

export const createFolderSuccessAction = (
  createFolderApiResponse: IFoldersDataServer
): ICeateFolderSuccessAction => {
  return {
    type: foldersActions.CREATE_FOLDER_SUCCESS,
    payload: createFolderApiResponse,
  };
};

export const createFolderFailureAction = (payload: {
  error: string;
}) => {
  return {
    type: foldersActions.CREATE_FOLDER_FAILURE,
    payload: payload,
  };
};


export const updateFolderAction = (
  payload: IFoldersDataServer
): IUpdateFolderAction => {
  return {
    type: foldersActions.UPDATE_FOLDER,
    payload,
  };
};

export const updateFolderSuccessAction = (
  updateFolderApiResponse: IFoldersDataServer
): IUpdateFolderSuccessAction => {
  return {
    type: foldersActions.UPDATE_FOLDER_SUCCESS,
    payload: updateFolderApiResponse,
  };
};

export const updateFolderFailureAction = (payload: {
  error: string;
}) => {
  return {
    type: foldersActions.UPDATE_FOLDER_FAILURE,
    payload: payload,
  };
};

export const deleteFolderAction = (
  folderId: string
): IDeleteFolderAction => {
  return {
    type: foldersActions.DELETE_FOLDER,
    payload: folderId,
  };
};

export const deleteFolderSuccessAction = (
  folderId: string
): IDeleteFolderSuccessAction => {
  return {
    type: foldersActions.DELETE_FOLDER_SUCCESS,
    payload: folderId,
  };
};

export const deleteFolderFailureAction = (payload: {
  error: string;
}) => {
  return {
    type: foldersActions.DELETE_FOLDER_FAILURE,
    payload: payload,
  };
};














export const getFolderByIdAction = (
  folderId: string
): IGetFolderByIdAction => {
  return {
    type: foldersActions.FETCH_FOLDER_BY_ID,
    payload: folderId,
  };
};

export const getFolderByIdSuccessAction = (
  folderData: IFoldersDataServer
): IGetFolderByIdSuccessAction => {
  return {
    type: foldersActions.FETCH_FOLDER_BY_ID_SUCCESS,
    payload: folderData,
  };
};

export const getFolderByIdFailureAction = (payload: {
  error: string;
}) => {
  return {
    type: foldersActions.FETCH_FOLDER_BY_ID_FAILURE,
    payload: payload,
  };
};






export const bulkUpdateFormFolderPathAction = (
  payload: IBulkUpdateFormFolderPathActionPayload
): IBulkUpdateFormFolderPathAction => {
  return {
    type: foldersActions.BULK_UPDATE_FORM_FOLDER_PATH,
    payload,
  };
};

export const bulkUpdateFormFolderPathSuccessAction = (
  payload: any
): IBulkUpdateFormFolderPathSuccessAction => {
  return {
    type: foldersActions.BULK_UPDATE_FORM_FOLDER_PATH_SUCCESS,
    payload,
  };
};

export const bulkUpdateFormFolderPathFailureAction = (payload: {
  error: string;
}) => {
  return {
    type: foldersActions.BULK_UPDATE_FORM_FOLDER_PATH_FAILURE,
    payload: payload,
  };
};
